import React from 'react';

export default ({ lat, lng, height, zoom })=> {
  console.log("Map: Renderizando componente con props:", { lat, lng, height, zoom });
  
  // URL para Google Maps
  const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}&z=${zoom}`;
  const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=600x400&markers=color:red%7C${lat},${lng}&key=YOUR_GOOGLE_MAPS_API_KEY`;
  
  // Usar imagen estática de OpenStreetMap para mostrar el mapa
  const osmStaticUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${lng-0.01},${lat-0.01},${lng+0.01},${lat+0.01}&marker=${lat},${lng}`;
  
  return (
    <div style={{ height, position: 'relative' }}>
      <iframe
        src={osmStaticUrl}
        style={{ 
          width: '100%', 
          height: '100%', 
          border: 'none',
          borderRadius: '4px'
        }}
        title="Ubicación de la propiedad"
      />
      <div style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        background: 'white',
        padding: '5px 10px',
        borderRadius: '3px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
      }}>
        <a 
          href={googleMapsUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#1976d2',
            textDecoration: 'none',
            fontSize: '12px',
            fontWeight: 'bold'
          }}
        >
          Ver en Google Maps
        </a>
      </div>
    </div>
  );
}